import {
  DefaultApi,
  InlineResponse200,
  AttachmentsV1PostRequest,
  AttachmentsV1IdGetRequest
} from '@/requests/imagesService'
import { IResponse, requestMachine } from '@/requests/requestMachine'

export default {
  loadPicture (variables: AttachmentsV1PostRequest): Promise<IResponse<InlineResponse200>> {
    return requestMachine<InlineResponse200, AttachmentsV1PostRequest>(
      DefaultApi,
      'attachmentsV1Post',
      true,
      variables
    )
  },
  getPictureById (variables: AttachmentsV1IdGetRequest): Promise<IResponse<Blob>> {
    return requestMachine<Blob, AttachmentsV1IdGetRequest>(
      DefaultApi,
      'attachmentsV1IdGet',
      true,
      variables
    )
  },
  startConvertDocs (): Promise<IResponse<InlineResponse200>> {
    return requestMachine<InlineResponse200>(
      DefaultApi,
      'attachmentsV1ConvertPost',
      true
    )
  }
}
